import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { MenuItem } from 'primeng/api';
import { Title } from '@angular/platform-browser';

@Injectable()
export class BreadcrumbService {

  constructor(
    private title: Title
  ) {}

  private itemsSource = new Subject<MenuItem[]>();

  itemsHandler = this.itemsSource.asObservable();

  setItems(items: MenuItem[]) {
    this.setTitle(items);
    this.itemsSource.next(items);
  }
  
  setTitle(items: MenuItem[]) {
    const label = items[0].label + (items[1] ? ` (${items[1].label})` : '');
    if (label) {
      this.title.setTitle(`Relatório Fotográfico - ${label}`);
    } else {
      this.title.setTitle(`Relatório Fotográfico`);
    }
  }
}